import React from 'react';
import './WireframeButton.scss';
import axios from 'axios'
import fileDownload from 'js-file-download'
import SystemConfiguration from 'settings/SystemConfiguration';
import Images from 'constants/Images';

class WireframeButton extends React.Component {
    constructor(props) {
      super(props);
      this.state = {render: true};
    }

    handleClick() {
        SystemConfiguration.wireframeEnabled = !SystemConfiguration.wireframeEnabled
        if(SystemConfiguration.material != null){
            if(!Array.isArray(SystemConfiguration.material)){
                SystemConfiguration.material.wireframe = !SystemConfiguration.material.wireframe
            } else {
                // console.log(SystemConfiguration.material)
                for(var i = 0; i < SystemConfiguration.material.length; i++){
                    SystemConfiguration.material[i].wireframe = !SystemConfiguration.material[i].wireframe
                }
            }
        }
            
      }

    render() {
        return (
            <img id="wireframebutton" src={process.env.PUBLIC_URL + Images.button_wireframe} onClick={() => this.handleClick()}/>
        );
    }
}

export default WireframeButton;